import * as React from 'react';
import { Card, Button, Tooltip, Icon, Typography, Modal, message, Input } from 'antd';
import moment from 'moment';
import { InquiryModes, UserRole, PERMISSON_ERROR_MESSAGE } from 'src/Library/Constants';
import ShareRateModal from './ShareRateModal';
import { getAllDataSetFilter } from 'src/actions/discoverRatesActions';
import { createBookingData, discoverRatesReportIssue } from 'src/api/discoverRates';
import { isDemoOrganisation } from 'src/utils/utils';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import { FetchedInquiries, SearchParams, SearchResult } from './TypesInDiscoverRates/SearchResult';
import { SelectedFilters } from './TypesInDiscoverRates/SelectedFilters';
import { Carrier } from 'src/Library/Types';
import { KYCData } from '../kycConnections/KycConnections.types';
import { buttonStyle } from 'src/Library/CommonStyles';
import { tokens } from 'src/design-system';
import { formatCurrency, formatDate, getTransitIcon } from './chargelistcard.utils';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getGAEventCategory, isSellRatesContentVisible, LINKING_STATUS } from './DiscoverRateUtils';
import Form, { FormComponentProps } from 'antd/lib/form';
import { SearchFilters } from './TypesInDiscoverRates/SearchFilters';
import { fetchKYC } from '../kycConnections/kycConnections.api';
import AdditionalEmailsForBookingModal from '../Enquiry/Modals/AdditionalEmailsForBookingModal';
import { bookingShipperRoute } from 'src/routing/utils';
import InformReason from '../Enquiry/Modals/InformReason';
import { ChargeListCardsStyles } from './ChargeListCards.styles';
import InquiryConfirmationModal from './InquiryConfirmationModal';
import CreateInquiryModal from '../Enquiry/Modals/CreateInquiryModal';
import BookingSuccessProtip from '../Enquiry/Modals/BookingSuccessProtip';
import FFConnectionRequestKYC from '../kycConnections/FFConnectionRequestKYC';

const { Text, Title } = Typography;
const { FCL, LCL, AIRCARGO, DOMESTIC, TRAILER, RPTL } = InquiryModes;

interface VerticalChargeCardProps extends FormComponentProps {
  classes: {
    [X in keyof ReturnType<typeof ChargeListCardsStyles>]: string;
  };
  data: any;
  topResult: any;
  searchFilters: SearchFilters;
  isItemPresent: {
    isLocalsPresent: boolean;
    activeKey: string;
    ffListMap: Record<string, { id: string; name: string; linkingStatus: LINKING_STATUS }>;
    handleNewInquiry: (disableFields?: boolean) => void;
    history: any;
  };
  buyRatesViewPermission?: boolean;
  orgType?: string;
  createInquiryPermission?: boolean;
  ffName?: string;
  businessTypeList?: any[];
  vendorRating?: string[];
  onShareRates?: (data: any) => void;
  onViewDetails?: (data: any) => void;
  userRole?: UserRole;
  shippingLines?: Carrier[];
  uuid?: string;
  getAllDataSetFilter: (val: Partial<SelectedFilters>, apiCall?: boolean) => void;
  selectedFilters: SelectedFilters;
  destinationServices?: string[];
  originServices?: string[];
}

interface StateProps {
  viewInformReason: boolean;
  remark: string;
  isReportModalVisible: boolean;
  isLoading: boolean;
  isReported: boolean;
  imgDimensions: {
    height: number;
    width: number;
  };
  isInquiryConfirmationVisible: boolean;
  inquiryData: FetchedInquiries[];
  searchParams?: SearchParams;
  isCreateInquiryModalVisible: boolean;
  protipVisible: boolean;
  inquiryDataResponse: any;
  isFFSelectionModalVisible: boolean;
  isFFConnectionRequestVisible: boolean;
  kycData: KYCData[];
  kycExists: boolean;
  weightSlabsDetails: {min: number, max: number}[] | null;
  isGeneratingBookingData: boolean;
  isBookingTnCModalVisible: boolean;
  isAdditionalEmailsModalVisible?: boolean;
  bookingId: string;
  bookingNumber: string;
}

const VerticalChargeCard: React.FC<VerticalChargeCardProps> = (props) => {
  const {
    classes,
    data,
    topResult,
    searchFilters,
    orgType,
    createInquiryPermission,
    ffName,
    vendorRating,
    onShareRates,
    isItemPresent,
    onViewDetails,
    selectedFilters,
    uuid,
    form,
  } = props;

  const { isLocalsPresent, activeKey, ffListMap, handleNewInquiry, history } = isItemPresent;
  const { isBulkNegotiationOn } = selectedFilters;
  const [shareModalVisible, setShareModalVisible] = React.useState(false);
  const { incoterm, movementType, shipperTeamId, mode = FCL, grossWeight, totalVolume, totalVolumetricWeight } = searchFilters;
  const { originServices, destinationServices } = selectedFilters;
  const [showDetails, setShowDetails] = React.useState(false);
  const [imgDimensions, setImgDimensions] = React.useState({ height: 0, width: 0 });
  const [state, setState] = React.useState<StateProps>({
    isReportModalVisible: false,
    isLoading: false,
    isReported: false,
    imgDimensions: {
      height: 0,
      width: 0,
    },
    isInquiryConfirmationVisible: false,
    inquiryData: [],
    isGeneratingBookingData: false,
    isBookingTnCModalVisible: false,
    searchParams: undefined,
    isCreateInquiryModalVisible: false,
    protipVisible: false,
    inquiryDataResponse: {},
    isFFSelectionModalVisible: false,
    isFFConnectionRequestVisible: false,
    kycData: [],
    kycExists: false,
    viewInformReason: false,
    remark: '',
    weightSlabsDetails: null,
    bookingId: '',
    bookingNumber: '',
  });

  const {
    isReportModalVisible,
    isInquiryConfirmationVisible,
    inquiryData,
    searchParams,
    isCreateInquiryModalVisible,
    bookingId,
    protipVisible,
    inquiryDataResponse,
    isGeneratingBookingData,
    isFFConnectionRequestVisible,
    kycData,
    kycExists,
    viewInformReason,
    remark,
    isAdditionalEmailsModalVisible,
    isLoading,
    bookingNumber,
  } = state;

  React.useEffect(() => {
    getImgHeightWidth();
  }, [data]);

  React.useEffect(() => {
    if (!(isCreateInquiryModalVisible || isFFConnectionRequestVisible || protipVisible || viewInformReason || shareModalVisible || isAdditionalEmailsModalVisible || isInquiryConfirmationVisible || isReportModalVisible)) return;
    const scrollY = window.scrollY;
    const originalCssText = document.body.style.cssText;
    document.body.style.cssText = `${originalCssText} position: fixed; top: -${scrollY}px; width: 100%; overflow: hidden;`;
    return () => { document.body.style.cssText = originalCssText; window.scrollTo(0, scrollY); };
  }, [isCreateInquiryModalVisible, isFFConnectionRequestVisible, protipVisible, viewInformReason, shareModalVisible, isAdditionalEmailsModalVisible, isInquiryConfirmationVisible, isReportModalVisible]);

  const getImgHeightWidth = () => {
    const img = new Image();
    const logoUrl = (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? (data.ffOrganisation?.logoUrl || data.carrier?.logoUrl) : data.carrier?.logoUrl;
    if (!logoUrl) return;

    img.src = logoUrl;
    const maxWidth = 60;
    const maxHeight = 40;
    img.onload = () => {
      const imgHeight = img.naturalHeight || img.height;
      const imgWidth = img.naturalWidth || img.width;
      const ratio = Math.min(maxWidth / imgWidth, maxHeight / imgHeight);
      const width = imgWidth * ratio;
      const height = imgHeight * ratio;
      setImgDimensions({ width, height });
    };
  };

  const isModeTypeRoadDomestic = mode === DOMESTIC;
  const isModeTypeTrailer = mode === TRAILER;
  const isModeTypeRPTL = mode === RPTL;
  const total = data.totalPrice || data.totalFreight;


  // Check if shipper can create inquiry
  const isShipperWithCreateInquiryPermission = () => {
    return orgType === 'SHIPPER' && createInquiryPermission && !(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL);
  };

  const handleProtipClose = () => {
    setStateUtil({
      protipVisible: false,
    });
    history.push(bookingShipperRoute());
  };

  // Check if rate is expired
  const isExpired = data?.validityEnd && moment(data.validityEnd) < moment();

  const getPortDataForBooking = (portType) => {
    return {
      port: portType.code,
      countryCode: portType.countryCode || portType.country_code,
      countryName: portType.countryName || portType.country_name,
    };
  };

  const getBookingData = () => {
    const { pol, pod, container, cargo, incoterm, movementType, mode, grossWeight,
    totalVolume, count = 1, length, breadth, height, dimensionUnit, totalVolumetricWeight } = searchFilters;
    const { noOfContainers, originServices, destinationServices } = selectedFilters;

    const searchUUID = localStorage.getItem('searchUUID');
    const containerDetails = JSON.parse(container || '[]')?.key;
    const {
      ffOrganisation,
      freightChargeId,
      originChargeId,
      destinationChargeId,
      criteriaId,
      criteriaRuleId,
    } = data;
    return {
      freightChargeId,
      originChargeId,
      destinationChargeId,
      criteriaId,
      criteriaRuleId,
      searchUUID,
      mode,
      origin: getPortDataForBooking(pol),
      destination: getPortDataForBooking(pod),
      container: {
        ...(containerDetails && containerDetails),
        count: count || noOfContainers,
        ...(length && {
          packageDimension: {
            height,
            breadth,
            length,
            unit: dimensionUnit,
          }
        }),
        ...(grossWeight && { weight: grossWeight }),
        ...(totalVolume && { volume: {...totalVolume, value: totalVolume.value / count}  }),
        ...(totalVolumetricWeight && { volumetricWeight: {...totalVolumetricWeight, value: totalVolumetricWeight.value / count}  })
      },
      cargo: {
        ...JSON.parse(cargo || '[]')?.key,
      },
      ffOrganisationId: ffOrganisation?.id,
      linkingStatus: ffListMap[data?.ffOrganisation?.id]?.linkingStatus,
      incoterm: incoterm || data?.incoterm, 
      movementType: movementType || data?.movementType,
      originServices, destinationServices,
    };
  };

  const handleCloseCreateBookingModal = (bookingNumber = undefined, bookingId = undefined) => {
    setStateUtil({
      bookingId,
      bookingNumber,
      isFFConnectionRequestVisible: false,
      isCreateInquiryModalVisible: false,
      protipVisible: bookingNumber ? true : false,
    });
  };

  const createBooking = async () => {
    setStateUtil({ isGeneratingBookingData: true });
    const body = getBookingData();
    const response = await createBookingData(body);
    if (!response.isSuccess) {
      message.error(response.errorMessage);
      setStateUtil({ isGeneratingBookingData: false });
    } else {
      setStateUtil({
        isCreateInquiryModalVisible: true,
        inquiryDataResponse: response.data,
        isGeneratingBookingData: false,
      });
    }
  };

  const handleBookNow = async () => {
    if (isDemoOrganisation()) {
      message.error(PERMISSON_ERROR_MESSAGE);
      return;
    }
    sendEvent(EventCategories.DISCOVER_RATES_BOOKING_SHIPPER, 'Discover rates Book - clicked');
    if (ffListMap[data?.ffOrganisation?.id]?.linkingStatus === LINKING_STATUS.NON_LINKED) {
      setStateUtil({ isGeneratingBookingData: true });
      const response = await fetchKYC();
      if (!response.isSuccess) {
        message.error(response.errorMessage);
        setStateUtil({ isGeneratingBookingData: false });
      } else {
        setStateUtil({
          isFFSelectionModalVisible: false,
          isFFConnectionRequestVisible: true,
          kycData: response.data?.kycData,
          kycExists: response.data?.kycExists,
          isGeneratingBookingData: false,
        });
      }
    } else {
      createBooking();
    }
  };

  const handleTnc = () => {
    data.rank === topResult?.rank ? handleBookNow() : openInformReason();
  };

  // Handle view details click
  const handleViewDetails = () => {
    setShowDetails(!showDetails);
    if (onViewDetails) onViewDetails(data);
  };

  const setStateUtil = (newState: Partial<StateProps>) => {
    setState((oldState: StateProps) => {
      return {
        ...oldState,
        ...newState,
      };
    });
  };

  // Handle share rates click
  const handleShareRates = (e) => {
    e.stopPropagation();
    setShareModalVisible(true);
    if (onShareRates) onShareRates(data);
  };

  const renderLine = (): React.ReactElement => {
    return <div style={{ height: '1px', width: '50px', backgroundColor: '#65b5f1' }} />;
  };
  
  const renderDot = (styles): React.ReactElement => {
    return <div style={{ height: '8px', width: '8px', borderRadius: '50%', ...styles }} />;
  };

  const openInformReason = () => {
    setStateUtil({
      viewInformReason: true,
    });
  };

  const renderLineAndDots = (): React.ReactElement => {
    return (
      <span style={{ display: 'flex', alignItems: 'center' }}>
        {renderDot({ border: '1px solid #666' })}
        {renderLine()}
        {data.transshipments?.length ? (
            <React.Fragment>
              {renderDot({
                backgroundColor: '#333333',
                height: '4px',
                width: '4px',
              })}
              {renderLine()}
            </React.Fragment>
          ) : null}
        {renderDot({ border: '1px solid #666' })}
      </span>
    );
  };

  const renderPort = (port, title): React.ReactElement => {
    const isPort = port?.type;
    const isCityMode = isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL;
    const displayText = isCityMode
      ? (port?.city || port?.name || port?.code || '-')
      : (!isPort ? port?.city : port?.code);
    const stateText = isCityMode ? port?.state?.trim() || null : null;
    return (
      <div style={{ minWidth: '120px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '4px' }}>
        <span style={{ fontSize: '11px', color: '#666', display: 'block' }}>{displayText || '-'}</span>
          {stateText && (
            <span style={{ fontSize: '10px', color: '#8c8c8c', maxWidth: '18ch', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {stateText}
            </span>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={port?.flagS3Link} style={{ maxWidth: '25px', alignSelf: 'center' }} />
        </div>
      </div>
    );
  };

  const renderRoute = (): React.ReactElement => {
    return (
      <div style={{width: (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? '45%' : '30%'}}>
        {data.isDirect === null ? (
          <Tooltip
            title={'Route: Not Available'}
            mouseEnterDelay={0.5}
          >
            <span style={{ color: '#CCCCCC', fontSize: '9px', visibility: (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? 'hidden' : 'initial' }}>Not Available</span>
          </Tooltip>
        ) : (
          <div style={{ fontSize: '10px', textAlign: 'center' }}>
            {!data.isDirect && data.transshipments?.length ? (
              <React.Fragment>
                <Tooltip
                  title={
                    <React.Fragment>
                      <span style={{ fontSize: '11px', backgroundColor: '#000000' }}>
                        Transshipment
                      </span>
                      <ul>
                        {data.transshipments?.length &&
                          data.transshipments.map((item) => (
                            <li key={item.code}>{`${item.name} (${item.code})`}</li>
                          ))}
                      </ul>
                    </React.Fragment>
                  }
                  mouseEnterDelay={0.5}
                >
                  {data.transshipments[0]?.code}
                  {data.transshipments.length > 1 && ` + ${data.transshipments.length - 1}`}
                </Tooltip>
              </React.Fragment>
            ) : (
              <Tooltip
                title={'Route: Direct'}
                mouseEnterDelay={0.5}
              >
                Direct
              </Tooltip>
            )}
          </div>
        )}
        {renderLineAndDots()}
        <div style={{fontSize: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          {getTransitIcon(mode)}
          &nbsp;
          {data.transitDays || data.transitDays === 0 ? (
            <Tooltip
              title={`Transit Days: ${data.transitDays}`}
              mouseEnterDelay={0.5}
            >
              <div style={{lineHeight: 1.1, marginBottom: isModeTypeTrailer ? '-5px' : 'unset', textAlign: 'center'}}>
                <div>{data.transitDays}</div>
                <div>{isModeTypeTrailer ? 'Hour' : 'Day'}{data?.transitDays > 1 ? 's' : ''}</div>
              </div>
            </Tooltip>
          ) : (
            <Tooltip
              title="Transit Days: Not Available"
              mouseEnterDelay={0.5}
            >
              <span style={{ color: '#CCCCCC', fontSize: '9px' }}>Not Available</span>
            </Tooltip>
          )}
        </div>
      </div>
    );
  };

  // Render carrier info
  const renderCarrierInfo = () => {
    const org = (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? data?.ffOrganisation : data?.carrier;
    
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        marginBottom: 16,
        width: '100%',
        position: 'relative',
      }}>
        {org?.logoUrl && (
          <img
            src={org?.logoUrl}
            style={{ ...imgDimensions, position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)' }}
            alt={org?.name ? `${org.name} Logo` : 'Vendor Logo'}
          />
        )}
        <div style={{ 
          fontWeight: 600, 
          fontSize: 18, 
          lineHeight: 1.2, 
          wordBreak: 'break-word',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textAlign: 'center',
        }}>
          {org?.name || '-'}
        </div>
      </div>
    );
  };

  const renderRouteInfo = () => {
    const origin = isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL ? data.origin : data.pol;
    const destination = isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL ? data.destination : data.pod;

    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
        {renderPort(origin, 'Origin')}
        {renderRoute()}
        {renderPort(destination, 'Destination')}
      </div>
    );
  };

  // Render charges
  const renderCharges = () => {
    return (
      <div style={{ margin: '16px 0' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: 8
        }}>
          <div>
            <div style={{ fontWeight: 500, color: '#666' }}>Total</div>
            <div style={{ color: '#8c8c8c', fontSize: 11 }}>
              {formatCurrency(total?.amount, total?.currency)}
            </div>
          </div>
          
          <div>
            <div style={{ fontWeight: 500, color: '#666' }}>Validity</div>
            <div style={{ color: '#8c8c8c', fontSize: 11 }}>
              {formatDate(data.validityEnd)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render action buttons
  const renderActions = () => {
    const orgName = data.shipperOrganisation?.name || data.ffOrganisation?.name;
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
        <div style={{ flex: 1 }}>
          {vendorRating && data.ffOrganisation?.rating && (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <div style={{ fontSize: 11, color: '#8c8c8c' }}>
                <span>
                  {orgType !== 'SHIPPER' && (data.type === 'BUY' ? 'Buy Rate' : 'FAK Price')}
                  {orgType !== 'SHIPPER' && ' | '}
                  {orgType === 'SHIPPER' && 'FF - '}
                  {data.ffOrganisation?.name || '-'}
                </span>
              </div>
              <div style={{ fontSize: 11, color: '#8c8c8c' }}>
                Source: {data.source === 'SPOT' ? 'CONTRACT' : data.source}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', fontSize: 11, color: '#8c8c8c' }}>
                <span style={{ marginRight: 4 }}>Vendor Rating:</span>
                <div>
                  {Array(5).fill(0).map((_, i) => (
                    <Icon
                      key={i}
                      type="star"
                      theme={i < (data.ffOrganisation.rating || 0) ? 'filled' : 'outlined'}
                      style={{ 
                        color: i < (data.ffOrganisation.rating || 0) ? '#faad14' : '#d9d9d9',
                        marginRight: 2
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button 
            icon="share-alt" 
            onClick={handleShareRates}
          />
        </div>
      </div>
    );
  };

  // Render charge breakdown
  const renderChargeBreakdown = () => {
    return (
      <div style={{ marginTop: 16, paddingTop: 16, borderTop: '1px solid #f0f0f0' }}>
        <div style={{ marginBottom: 16 }}>
          <h3 style={{ marginBottom: 12 }}>Charge Breakdown</h3>
          
          {Object.entries(data.chargeBreakdown || {}).map(([key, charges]) => (
            <div key={key} style={{ marginBottom: 16 }}>
              <div style={{ 
                fontWeight: 500, 
                marginBottom: 8,
                textTransform: 'capitalize'
              }}>
                {key.replace(/([A-Z])/g, ' $1').trim()}
              </div>
              
              {/* Column Headers */}
              <div style={{ 
                display: 'grid',
                gridTemplateColumns: '2fr 1fr 1fr 1fr',
                gap: 8,
                padding: '8px 0',
                color: '#666',
                fontSize: '12px',
                borderBottom: '1px solid #f0f0f0',
                fontWeight: 500
              }}>
                <div style={{ textAlign: 'center' }}>Charges</div>
                <div style={{ textAlign: 'center' }}>Price Per Unit</div>
                <div style={{ textAlign: 'center' }}>No. of Units</div>
                <div style={{ textAlign: 'center' }}>Total Price</div>
              </div>
              
              {/* Charge Items */}
              {(charges as any[]).map((charge, index) => (
                <div 
                  key={index}
                  style={{ 
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr',
                    gap: 8,
                    padding: '8px 0',
                    borderBottom: '1px solid #f0f0f0',
                    alignItems: 'center',
                    fontSize: '13px'
                  }}
                >
                  <div style={{ fontWeight: 500 }}>{charge.name?.trim()}</div>
                  <div>
                    {charge.currency} {charge.amount?.toFixed(2)}
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    {charge.unitCount || '1'}
                  </div>
                  <div style={{ textAlign: 'right', fontWeight: 500 }}>
                    {charge.currency} {charge.total?.toFixed(2)}
                  </div>
                </div>
              ))}
            </div>
          ))}

          <div style={{ 
            backgroundColor: '#fafafa', 
            padding: 12, 
            borderRadius: 4,
            marginTop: 8,
            marginBottom: 8
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 500, marginBottom: 8 }}>
              <span>Total</span>
              <span>{formatCurrency(total?.amount, total?.currency)}</span>
            </div>
            
            {/* Exchange Rates */}
            {data.exchangeRate && Object.keys(data.exchangeRate).length > 0 && (
              <div style={{ fontSize: '12px', color: '#666', borderTop: '1px solid #f0f0f0', paddingTop: 8 }}>
                <div style={{ fontWeight: 500, marginBottom: 4 }}>Exchange Rates:</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  {Object.entries(data.exchangeRate).map(([key, rate]) => {
                    const [fromCurrency, toCurrency] = key.split('-');
                    return (
                      <div key={key}>
                        {`1 ${fromCurrency} = ${rate} ${toCurrency}`}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>

        {(data.freeDaysOrigin || data.demurrageFreeDays || data.detentionFreeDays || data.cfsFreeDays || data.combinedFreeDays) && (
          <div style={{ marginTop: 16 }}>
            <div style={{ fontWeight: 600, color: '#666' }}>Free Days</div>
            {/* <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}> */}
              {data.demurrageFreeDays !== null && (
                <div>
                  <div style={{ fontWeight: 200, color: '#666', fontSize: 12 }}>Demurrage Free Days - {data.demurrageFreeDays}</div>
                </div>
              )}
              {data.detentionFreeDays !== null && (
                <div>
                  <div style={{ fontWeight: 200, color: '#666', fontSize: 12 }}>Detention Free Days - {data.detentionFreeDays}</div>
                </div>
              )}
              {data.freeDaysOrigin !== null && (
                <div>
                  <div style={{ fontWeight: 200, color: '#666', fontSize: 12 }}>Origin Free Days - {data.freeDaysOrigin}</div>
                </div>
              )}
              {data.cfsFreeDays !== null && (
                <div>
                  <div style={{ fontWeight: 200, color: '#666', fontSize: 12 }}>CFS Free Days - {data.cfsFreeDays}</div>
                </div>
              )} 
              {data.combinedFreeDays !== null && (
                <div>
                  <div style={{ fontWeight: 200, color: '#666', fontSize: 12 }}>Combined Free Days - {data.combinedFreeDays}</div>
                </div>
              )}    
            {/* </div> */}
          </div>
        )}

        {/* Always show Internal Reference field */}
        <div style={{ marginTop: 16 }}>
          <div style={{ fontWeight: 500, color: '#666', marginBottom: 4 }}>Internal Reference</div>
          <div style={{ color: '#8c8c8c', fontSize: 12 }} >{data?.internalReferenceNumber ? data?.internalReferenceNumber : '-'}</div>
        </div>

        {/* Show Stuffing Location */}
        <div style={{ marginTop: 12 }}>
          <div style={{ fontWeight: 500, color: '#666', marginBottom: 4 }}>Stuffing Location</div>
          <div style={{ color: '#8c8c8c', fontSize: 12, textOverflow: 'unset', whiteSpace: 'unset'}}>
            {((isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? data?.origin?.displayAddress : data?.stuffingLocations?.[0]?.displayAddress) || '-'}
          </div>
        </div>

        {/* Show De-stuffing Location */}
        <div style={{ marginTop: 12 }}>
          <div style={{ fontWeight: 500, color: '#666', marginBottom: 4 }}>De-stuffing Location</div>
          <div style={{ color: '#8c8c8c', fontSize: 12, textOverflow: 'unset', whiteSpace: 'unset'}}>
            {((isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? data?.destination?.displayAddress : data?.destuffingLocations?.[0]?.displayAddress) || '-'}
          </div>
        </div>

        {/* Always show Remarks field */}
        <div style={{ marginTop: 12 }}>
          <div style={{ fontWeight: 500, color: '#666', marginBottom: 4 }}>Remarks</div>
          <div style={{ color: '#8c8c8c', fontSize: 12 }}>{data?.remarks ? data?.remarks : '-'}</div>
        </div>
      </div>
    );
  };

  const handleShareRateModal = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setShareModalVisible((prevState) => !prevState);
  };

  const closeInformReason = () => {
    setStateUtil({
      viewInformReason: false,
    });
  };

  const setRemark = (val) => {
    setStateUtil({ remark: val });
  };

  const renderInformReasonModal = (): React.ReactElement => {
    const selectedBid = {
      id: data.id,
      shipperTotalWithoutTax: {
        amount: data.totalPrice?.amount,
        currency: data.totalPrice?.currency,
      },
    };
    const topRankBid = {
      id: topResult?.freightChargeId,
      shipperTotalWithoutTax: {
        amount: topResult?.totalPrice?.amount,
        currency: topResult?.totalPrice?.currency,
      },
    };
    return (
      <InformReason
        mode={searchFilters?.mode??FCL}
        type={'SHIPPER'}
        booking={true}
        topRankBid={topRankBid}
        selectedBid={selectedBid}
        visible={viewInformReason}
        handleCancel={closeInformReason}
        createBooking={handleBookNow}
        setRemark={setRemark}
        heading="Reason"
      />
    );
  };

  const handleSubmit = (): void => {
    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      setStateUtil({ isLoading: true });
      const searchRequest = {
        polId: searchFilters?.pol?.id,
        podId: searchFilters?.pod?.id,
        container: JSON.parse(searchFilters?.container)?.key,
        cargo: JSON.parse(searchFilters?.cargo)?.key,
        mode: searchFilters?.mode,
      };
      const body = {
        ...values,
        data,
        searchRequest: {
          ...searchRequest,
          view: activeKey,
          ...(activeKey === 'SELL' && {
            shipperOrganisationId:
              searchFilters?.shipperOrganisationId === 'nonLinkedShippers'
                ? undefined
                : searchFilters?.shipperOrganisationId,
            isNonLinkedShipperSelected:
              searchFilters?.shipperOrganisationId === 'nonLinkedShippers',
          }),
        },
      };
      const response = await discoverRatesReportIssue(body, activeKey);
      if (response.isSuccess) {
        getGAEventCategory(orgType, 'Report an Issue');
        setStateUtil({ isReportModalVisible: false, isReported: true });
        message.success('Thanks for your feedback. Our team will verify this rate');
      } else {
        getGAEventCategory(orgType, 'Report an Issue - Failed');
        message.error(response.errorMessage);
      }
      setStateUtil({ isLoading: false });
    });
  };

  const openReportModal = (): React.ReactElement => {
    const modalTitle: React.ReactElement = (
      <span className={classes.modalTitle}>
        <Icon type="exclamation-circle" theme="filled" className={classes.reportIcon} /> Report
      </span>
    );
    const modalFooter: React.ReactElement = (
      <Button
        className={classes.reportSubmit}
        disabled={!form.getFieldValue('reason')}
        onClick={handleSubmit}
        loading={isLoading}
      >
        Submit
      </Button>
    );
    return (
      <Modal
        visible={isReportModalVisible}
        title={modalTitle}
        className={classes.reportModal}
        destroyOnClose
        onCancel={() => setStateUtil({ isReportModalVisible: false })}
        footer={modalFooter}
      >
        <span>Please write, why you want to report?</span>
        <Form.Item className={classes.error}>
          {form.getFieldDecorator('reason', {
            rules: [{ required: true, message: 'Reason is required' }],
          })(<Input.TextArea style={{ marginTop: '12px' }} rows={3} />)}
        </Form.Item>
      </Modal>
    );
  };

  return (
    <Card 
      style={{ 
        marginBottom: 16,
        borderRadius: 8,
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02)',
        border: '1px solid #f0f0f0',
        transition: 'box-shadow 0.3s, border-color 0.3s'
      }}
      bodyStyle={{ padding: 16 }}
    >
      {renderCarrierInfo()}
      {renderRouteInfo()}
      {renderCharges()}
      {renderActions()}
      {renderChargeBreakdown()}
      {isReportModalVisible && openReportModal()}
      {isInquiryConfirmationVisible && (
        <InquiryConfirmationModal
          isVisible={isInquiryConfirmationVisible}
          inquiryData={inquiryData}
          searchParams={searchParams}
          onOk={() => handleNewInquiry(true)}
          onConfirmationClose={() => {
            getAllDataSetFilter(
              {
                organisationList: undefined,
                isBulkNegotiationOn: false,
              },
              false
            );
            setStateUtil({
              isInquiryConfirmationVisible: false,
              inquiryData: [],
              searchParams: undefined,
            });
          }}
        />
      )}
      {isCreateInquiryModalVisible && (
        <CreateInquiryModal
          handleCancel={handleCloseCreateBookingModal}
          visible={isCreateInquiryModalVisible}
          data={inquiryDataResponse}
          fromDiscoverRates={true}
          freightChargeId={data.freightChargeId}
          bookingReason={remark}
          incoterm={incoterm}
          movementType={movementType}
          originServices={originServices}
          destinationServices={destinationServices}
          mode={mode} grossWeight={grossWeight} totalVolume={totalVolume}
        />
      )}
      {protipVisible && (
        <BookingSuccessProtip
          bookingId={bookingNumber}
          visible={protipVisible}
          handleClose={handleProtipClose}
          handleNotifyUsers={() => setStateUtil({ isAdditionalEmailsModalVisible: true, protipVisible: false })}
        />
      )}
      {isFFConnectionRequestVisible && (
        <FFConnectionRequestKYC
          isVisible={isFFConnectionRequestVisible}
          ffOrganisation={data.ffOrganisation}
          firstTime={!kycExists}
          kycData={kycData}
          createBooking={createBooking}
          isGeneratingBookingData={isGeneratingBookingData}
          onCancel={() => setStateUtil({ isFFConnectionRequestVisible: false })}
        />
      )}
      {viewInformReason && renderInformReasonModal()}
      {shareModalVisible && (
        <ShareRateModal
          freightChargeId={data?.freightChargeId}
          originChargeId={data?.originChargeId}
          destinationChargeId={data?.destinationChargeId}
          criteriaId={data?.criteriaId}
          criteriaRuleId={data?.criteriaRuleId}
          polName={data?.pol?.name}
          podName={data?.pod?.name}
          FFName={data?.ffOrganisation?.name ?? ffName}
          containerCount={selectedFilters?.noOfContainers ?? ''}
          cargo={{ ...JSON.parse(searchFilters?.cargo || '{}')?.label }}
          container={{ ...JSON.parse(searchFilters?.container || '{}')?.label }}
          freightValidity={moment(data?.validityEnd).format('DD MMM YYYY')}
          shipperId={searchFilters?.shipperOrganisationId}
          handleModal={handleShareRateModal}
          incoterm={incoterm}
          movementType={movementType}
          shipperTeamId={shipperTeamId}
          originServices={originServices}
          destinationServices={destinationServices}
          view={activeKey}
          uuid={uuid}
          mode={mode} 
          grossWeight={grossWeight} 
          totalVolume={totalVolume}
          totalVolumetricWeight={totalVolumetricWeight}
        />
      )}
      {isAdditionalEmailsModalVisible && (
        <AdditionalEmailsForBookingModal
          bookingId={bookingId}
          isVisible={isAdditionalEmailsModalVisible}
          handleCancel={() => {
            setStateUtil({ isAdditionalEmailsModalVisible: false, protipVisible: true });
          }}
          handleSuccess={() => {
            setStateUtil({ isAdditionalEmailsModalVisible: false });
            history.push(
              bookingShipperRoute(),
              { successMessage: 'Booking updates have been sent successfully to users!' },
            );
          }}
        />
      )}

      {isShipperWithCreateInquiryPermission() && data?.ffOrganisation && !isExpired && (
        <div style={{ padding: '0 16px 16px', textAlign: 'right', borderTop: '1px solid #f0f0f0', paddingTop: '16px' }}>
          <Button
            onClick={() => handleTnc()}
            style={{ opacity: isBulkNegotiationOn ? 0.8 : 1, ...buttonStyle(tokens.colors.bgWhite, tokens.colors.primaryDark, `1px solid ${tokens.colors.primaryDark}`) }}
            disabled={isBulkNegotiationOn}
            loading={isGeneratingBookingData}
          >
            Book
          </Button>
        </div>
      )}
    </Card>
  );
};


const mapStateToProps = ({ masterData, discoverRatesReducer, inquiryReducer, rateMasterReducer }) => ({
  form: inquiryReducer.form,
  getAllDataSetFilter: inquiryReducer.getAllDataSetFilter,
  searchFilters: discoverRatesReducer.searchFilters,
  selectedFilters: discoverRatesReducer.selectedFilters,
  rateMasterData: discoverRatesReducer.ratesMasterData,
  buyRatesViewPermission: masterData.permissions.DISCOVER_BUY_RATES_VIEW,
  orgType: masterData.userData.type,
  userRole: masterData.userData.role,
  ffName: masterData.userData.ff_name,
  createInquiryPermission: masterData.permissions.INQUIRY_ALL_ACTIONS,
  shippingLines: masterData.globalShippingLines,
  uuid: discoverRatesReducer.uuid,
  showMarkupCriteria: masterData?.modules?.show_markup_criteria,
  businessTypeList: rateMasterReducer.ratesMasterData?.businessTypesList,
  vendorRating: Object.values(masterData?.vendorRating?.mapping || {}),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const VerticalChargeCardConnected = connect(mapStateToProps, mapDispatchToProps)(VerticalChargeCard);

export default VerticalChargeCardConnected;
